<template>
  <div class="mobile-ban">
    <Header
      class="header"
      backgroundColor="rgba(11, 11, 11, .75)"
      :isAbsolute="false"
    />
    <img class="tw" src="@/assets/images/mobile-alert.svg" alt="" />
    <img class="en" src="@/assets/images/mobile-alert-en.svg" alt="" />
    <div class="bottom-text">
      <p @click="goUrl('https://virsody.io/pricing')">
        <!-- 查看服務方案 -->
        {{ $t('COMMON.WORD.CHECK_SERVICE_PLAN') }}
      </p>
      <p @click="goUrl('https://virsody.io/')">
        <!-- 回首頁 -->
        {{ $t('COMMON.WORD.GO_BACK_HOME') }}
      </p>
    </div>
  </div>
</template>
<script>
import Header from '@/components/OfficialHeader.vue';
export default {
  name: 'MobileBan',
  components: { Header },
  methods: {
    goUrl(url) {
      location.href = url;
    }
  }
};
</script>
<style lang="scss" scoped>
.mobile-ban {
  position: fixed;
  background-color: black;
  display: none;
  min-height: 500px;
  z-index: 9999;
  width: 100vw;
  height: 100%;
  top: 0;
  left: 0;
  @media screen and (max-width: 768px) {
    display: block;
  }
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  p {
    font-size: 18px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 30%;
    &:nth-child(2) {
      color: #00b6f0;
    }
  }
  .bottom-text {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
  }
}
</style>